// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3nZ2s";
var _4 = "inner-1DWCP";
var _5 = "submit-1Q0jl";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "inner", _5 as "submit" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "inner": _4, "submit": _5 }
